import { ClinicsService } from '@services/clinics.service';
import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { AccessLocationService } from '@services/access-location.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from '@app/management/dialogs/confirm-delete/confirm-delete.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-access-locations',
  templateUrl: './access-locations.component.html',
  styleUrls: ['./access-locations.component.less'],
})
export class AccessLocationsComponent implements OnInit, OnDestroy {
  gridData: any[];
  unsub = new Subject<any>();
  loading = false;
  clinicId: number;
  @Output() disableLoadingEvent = new EventEmitter<boolean>();
  constructor(
    private accessLocationService: AccessLocationService,
    private clinicsService: ClinicsService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.clinicsService.clinicIdSelected$
      .asObservable()
      .pipe(takeUntil(this.unsub))
      .subscribe((clinicId) => {
        this.clinicId = clinicId;
        this.getAccessLocationData();
      });
    this.getAccessLocationData();
    this.accessLocationService.accessLocationUpdateSource$.pipe(takeUntil(this.unsub)).subscribe((res) => {
      if (res) {
        this.getAccessLocationData();
      }
      this.disableLoadingEvent.emit(res);
    });
  }

  private getAccessLocationData() {
    this.loading = true;
    this.accessLocationService.getAccessLocations(this.clinicId).subscribe((res) => {
      this.gridData = res;
      this.loading = false;
      this.disableLoadingEvent.emit(false);
    });
  }

  public onAddClick({ sender }) {
    this.disableLoadingEvent.emit(true);
    this.accessLocationService.shareAccessLocation(null);
    this.router.navigate([
      '/management/organization/clinics/general',
      { outlets: { 'action-panel': ['edit-access-location', '_'] } },
    ]);
  }

  public editHandler({ sender, rowIndex, dataItem }) {
    this.disableLoadingEvent.emit(true);
    this.accessLocationService.shareAccessLocation(dataItem);
    this.router.navigate([
      '/management/organization/clinics/general',
      { outlets: { 'action-panel': ['edit-access-location', dataItem.id] } },
    ]);
  }

  public removeHandler({ dataItem }) {
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: '250px',
      data: {
        extraMessage: 'This action will remove this access location.',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'delete') {
        this.accessLocationService.deleteAccessLocations(dataItem).subscribe(() => {
          this.getAccessLocationData();
        });
      }
    });
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
